import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function CommunicationIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4_4670)">
        <path
          d="M76.3441 24.9463H28.6022C26.6667 24.9463 24.9462 26.6667 24.9462 28.6022V66.2366C24.9462 68.1721 26.6667 69.8925 28.6022 69.8925H67.5269L80 80.0001V28.6022C80 26.6667 78.4946 24.9463 76.3441 24.9463Z"
          fill="#00C4B3"
        />
        <path
          d="M67.5269 47.957C67.5269 43.871 65.8064 40 63.0107 36.9893C60 33.9785 56.129 32.4731 51.828 32.4731C47.7419 32.4731 43.6559 34.1936 40.6452 36.9893C37.6344 40 36.129 43.871 36.129 48.1721C36.129 52.2581 37.8495 56.3441 40.6452 59.3549C43.4409 62.1506 47.3118 63.871 51.3978 63.871H51.6129C55.6989 63.871 59.7849 62.1506 62.7957 59.3549L63.2258 58.9248L60.8602 56.5592L60.4301 56.9893C58.0645 59.3549 55.0538 60.6452 51.828 60.6452C48.6021 60.6452 45.3763 59.3549 43.2258 56.9893C40.8602 54.6237 39.5699 51.6129 39.5699 48.3871C39.5699 45.1613 40.8602 41.9355 43.2258 39.785C45.5914 37.4194 48.6021 36.1291 51.828 36.1291C55.0538 36.1291 58.2796 37.4194 60.4301 39.785C62.3656 41.7205 63.4409 44.086 63.871 46.6667H61.5054H61.2903C60.8602 44.7312 60 43.0108 58.4946 41.5054C56.5591 39.5699 54.1935 38.7097 51.6129 38.7097C49.0323 38.7097 46.4516 39.785 44.7312 41.5054C42.7957 43.4409 41.9355 45.8065 41.9355 48.3871C41.9355 50.9678 43.0107 53.3334 44.7312 55.2688C46.4516 56.9893 48.8172 58.0645 51.3978 58.0645H51.6129C54.1935 58.0645 56.5591 56.9893 58.4946 55.2688L58.9247 54.8387L56.5591 52.4731L56.129 52.9033C54.8387 54.1936 53.3333 54.8387 51.6129 54.8387C49.8925 54.8387 48.3871 54.1936 47.0968 52.9033C46.2366 52.043 45.8065 51.1828 45.3763 50.1076H49.6774H51.3978H58.0645H61.5054H67.5269V47.957ZM51.828 46.4516H50.1075H45.8064C46.0215 45.3764 46.6667 44.5162 47.5269 43.6559C48.8172 42.3656 50.3226 41.7205 52.043 41.7205C53.7634 41.7205 55.2688 42.3656 56.5591 43.6559C57.4194 44.5162 57.8495 45.3764 58.2796 46.4516H51.828Z"
          fill="white"
        />
        <path
          d="M51.3979 0H3.65591C1.72043 0 0 1.72043 0 3.65591V55.0538L12.4731 44.9462H51.3979C53.3333 44.9462 55.0538 43.2258 55.0538 41.2903V3.65591C55.0538 1.72043 53.3333 0 51.3979 0Z"
          fill="#EAEEF9"
        />
        <path
          d="M46.2366 29.8925H44.086C43.6559 29.8925 43.4409 29.4624 43.4409 29.2473V16.129C43.4409 15.6989 43.871 15.4839 44.086 15.4839H46.2366C47.7419 15.4839 49.2473 16.7742 49.2473 18.4946V27.3118C49.0323 28.6022 47.7419 29.8925 46.2366 29.8925Z"
          fill="#00416B"
        />
        <path
          d="M40.8602 30.3226L28.172 38.9247C26.8817 39.7849 25.3763 38.9247 25.3763 37.4193V7.95697C25.3763 6.45159 27.0968 5.59138 28.172 6.45159L40.8602 15.0537C41.0753 15.2688 41.2903 15.6989 41.2903 15.914V29.2473C41.5054 29.6774 41.2903 30.1075 40.8602 30.3226Z"
          fill="#00C4B3"
        />
        <path
          d="M12.6882 38.9247C12.4731 38.9247 12.043 38.9247 11.828 38.7096C7.52688 34.4085 5.37634 28.8171 5.37634 22.7956C5.37634 16.7741 7.74193 11.1827 11.828 6.88166C12.4731 6.45156 13.1183 6.45156 13.5484 6.88166C13.9785 7.31177 13.9785 7.95693 13.5484 8.38704C9.67742 12.258 7.52688 17.2042 7.52688 22.5806C7.52688 27.9569 9.67742 33.1182 13.5484 36.7741C13.9785 37.2042 13.9785 37.8494 13.5484 38.2795C13.3333 38.7096 12.9032 38.9247 12.6882 38.9247Z"
          fill="#00416B"
        />
        <path
          d="M16.7742 33.7635C16.5591 33.7635 16.129 33.7635 15.914 33.5484C9.89247 27.5269 9.89247 17.8495 15.914 12.043C16.3441 11.6129 16.9892 11.6129 17.4194 12.043C17.8495 12.4731 17.8495 13.1183 17.4194 13.5484C12.2581 18.7097 12.2581 26.8817 17.4194 32.043C17.8495 32.4731 17.8495 33.1183 17.4194 33.5484C17.4194 33.7635 17.2043 33.7635 16.7742 33.7635Z"
          fill="#00416B"
        />
        <path
          d="M21.0753 28.8172C20.8602 28.8172 20.4301 28.8172 20.2151 28.6021C16.9892 25.3763 16.9892 20.215 20.2151 16.9892C20.6452 16.5591 21.2903 16.5591 21.7204 16.9892C22.1505 17.4193 22.1505 18.0645 21.7204 18.4946C20.6452 19.5699 20 21.0752 20 22.7957C20 24.301 20.6452 25.8064 21.7204 27.0967C22.1505 27.5268 22.1505 28.172 21.7204 28.6021C21.5054 28.8172 21.2903 28.8172 21.0753 28.8172Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_4_4670">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
